var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgStar00(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_star_00",
    filter: "url(#filter0_d_122_114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5254 7.61076C18.717 5.87205 21.283 5.87204 22.4746 7.61076L25.0397 11.3535C25.4297 11.9227 26.0041 12.34 26.666 12.5351L31.0182 13.818C33.04 14.414 33.833 16.8544 32.5476 18.525L29.7807 22.1211C29.3599 22.668 29.1405 23.3432 29.1595 24.033L29.2842 28.5686C29.3422 30.6756 27.2662 32.1839 25.2802 31.4776L21.0051 29.9574C20.355 29.7262 19.645 29.7262 18.9949 29.9574L14.7198 31.4776C12.7338 32.1839 10.6578 30.6756 10.7158 28.5686L10.8405 24.033C10.8595 23.3432 10.6401 22.668 10.2193 22.1211L7.45244 18.525C6.16705 16.8544 6.95998 14.414 8.98183 13.818L13.334 12.5351C13.9959 12.34 14.5703 11.9227 14.9603 11.3535L17.5254 7.61076Z",
    fill: "#FFD402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.665 31.8418L18.9949 29.9574L19.665 31.8418C19.8817 31.7648 20.1183 31.7648 20.335 31.8418L24.6101 33.362C27.9202 34.5391 31.38 32.0254 31.2835 28.5136L31.1587 23.978C31.1524 23.7481 31.2255 23.523 31.3658 23.3407L34.1327 19.7446C36.275 16.9603 34.9534 12.893 31.5837 11.8996L27.2315 10.6167C27.0109 10.5517 26.8194 10.4125 26.6894 10.2228L24.1244 6.48012C22.1383 3.58225 17.8617 3.58226 15.8756 6.48012L13.3106 10.2228C13.1806 10.4126 12.9891 10.5517 12.7685 10.6167L8.41632 11.8996C5.04657 12.893 3.72502 16.9603 5.86733 19.7446L8.63421 23.3407L10.2193 22.1211L8.63421 23.3407C8.77447 23.523 8.84761 23.7481 8.84128 23.978L8.71654 28.5136C8.61995 32.0254 12.0798 34.5391 15.3899 33.362L19.665 31.8418Z",
    stroke: "white",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_122_114",
    x: 0.825928,
    y: 0.306763,
    width: 38.3481,
    height: 37.3506,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_122_114"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_122_114",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgStar00);
export default __webpack_public_path__ + "static/media/img_star_00.b491cc96932c15f0c50cc03c82b3517b.svg";
export { ForwardRef as ReactComponent };